import React, { useContext } from 'react';
import { TextField } from '@material-ui/core';
import { VisitsGlobalContext } from '@mummssoftware/global-context';
import { AppContext } from '../../context';
import {
  FilterHeader,
  FilterContainer,
} from '../../components/layout/WrapperDiv';
import { SummaryFilterContext } from './SummaryFilters';
import { filterByLateChart } from '../../translations/en.json';

export const LateChartFilter = () => {
  const { patient } = useContext(AppContext);
  const { chartAfterDD, chartAfterHH } = useContext(VisitsGlobalContext);
  const { tentativeFilters, updateTentFilters, getInputStyles } = useContext(
    SummaryFilterContext,
  );

  const setChartDD = (date: any) => {
    updateTentFilters({ ...tentativeFilters, chartAfterDD: date });
  };
  const setChartHH = (date: any) => {
    updateTentFilters({ ...tentativeFilters, chartAfterHH: date });
  };

  const chartDDChanged = chartAfterDD !== tentativeFilters.chartAfterDD;
  const chartHHChanged = chartAfterHH !== tentativeFilters.chartAfterHH;

  const ddClasses = getInputStyles(chartDDChanged);
  const hhClasses = getInputStyles(chartHHChanged);

  const inputDDProps = {
    classes: {
      root: ddClasses.root,
      input: ddClasses.input,
    },
  };
  const inputHHProps = {
    classes: {
      root: hhClasses.root,
      input: hhClasses.input,
    },
  };

  return (
    <FilterContainer className="visit-log-length-filter">
      <FilterHeader selected={chartDDChanged || chartHHChanged}>
        {filterByLateChart}
      </FilterHeader>
      {patient || (
        <div style={{ display: 'flex', paddingTop: '8px' }}>
          <div style={{ display: 'flex', height: '10px' }}>
            <TextField
              label="DD"
              id="dd-edit"
              variant="outlined"
              value={tentativeFilters.chartAfterDD}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={inputDDProps}
              onChange={(e: any) => {
                setChartDD(e.target.value);
              }}
              size="small"
            />
            <div>:</div>
            <TextField
              label="HH"
              id="hh-edit"
              variant="outlined"
              value={tentativeFilters.chartAfterHH}
              InputProps={inputHHProps}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e: any) => {
                setChartHH(e.target.value);
              }}
              size="small"
            />
          </div>
        </div>
      )}
    </FilterContainer>
  );
};
